import React, { Component } from 'react';
import './cores.css';

class Cores extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banda1: '0',
      banda2: '0',
      banda3: '1',
      banda4: '±0%',
      select: 'ab',
      vartext: '',
    }
    this.mudacorpreto = this.mudacorpreto.bind(this);
    this.mudacormarrom = this.mudacormarrom.bind(this);
    this.mudacorvermelho = this.mudacorvermelho.bind(this);
    this.mudacorlaranja = this.mudacorlaranja.bind(this);
    this.mudacoramarelo = this.mudacoramarelo.bind(this);
    this.mudacorverde = this.mudacorverde.bind(this);
    this.mudacorazul = this.mudacorazul.bind(this);
    this.mudacorvioleta = this.mudacorvioleta.bind(this);
    this.mudacorbranco = this.mudacorbranco.bind(this);
    this.mudacorcinza = this.mudacorcinza.bind(this);
    this.gold = this.gold.bind(this);
    this.silver = this.silver.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  seleciona(cor) {
    this.setState({
      select: cor,
    });
  }
  handleCor1(cor) {
    this.setState({
      banda1: cor
    });
  }
  handleCor2(cor) {
    this.setState({
      banda2: cor
    });
  }
  handleCor3(cor) {
    this.setState({
      banda3: cor
    });
  }
  handleCor4(cor) {
    this.setState({
      banda4: cor
    });
  }
  mudacorpreto() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#000';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('0');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('0');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('1');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('');
          }
  }
  mudacormarrom() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#641e16';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('1');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('1');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('10');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±1%');
          }
  }
  mudacorvermelho() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#ff0000';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('2');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('2');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('100');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±2%');
          }
  }
  mudacorlaranja() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#ffa500';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('3');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('3');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('1000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±0.05%');
          }
  }
  mudacoramarelo() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#ffff00';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('4');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('4');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('10000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±0.02');
          }
  }
  mudacorverde() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#00dd00';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('5');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('5');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('100000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±0.5%');
          }
  }
  mudacorazul() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#00F';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('6');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('6');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('1000000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±0.25%');
          }
  }
  mudacorvioleta() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#ee82ee';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('7');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('7');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('10000000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±0.11%');
          }
  }
  mudacorcinza() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#777';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('8');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('8');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('100000000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('±0.01%');
          }
  }
  mudacorbranco() {
    let x, i;
    x = document.querySelectorAll("#" + this.state.select);
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#FFF';
    }
    if (this.state.select === 'ab') {
      this.handleCor1('9');
    } else
      if (this.state.select === 'ac') {
        this.handleCor2('9');
      } else
        if (this.state.select === 'ad') {
          this.handleCor3('1000000000');
        } else
          if (this.state.select === 'ae') {
            this.handleCor4('');
          }
  }
  handleClick = (e) => {
    this.seleciona(e.target.id);
  }
  gold() {
    let x, i;
    x = document.querySelectorAll("#ae");
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#ffd700';
    }
    this.handleCor4('±5%')
  }
  silver() {
    let x, i;
    x = document.querySelectorAll("#ae");
    for (i = 0; i < x.length; i++) {
      x[i].style.backgroundColor = '#c0c0c0';
    }
    this.handleCor4('±10%')
  }
  calcula() {
    let bandaA = this.state.banda1 ? parseFloat(this.state.banda1) : 0;
    let bandaB = this.state.banda2 ? parseFloat(this.state.banda2) : 0;
    let bandaC = this.state.banda3 ? parseFloat(this.state.banda3) : 0;
    let resultado;

    resultado = (bandaA * 10 + bandaB) * bandaC;

    if (resultado >= 1000000) {
      resultado /= 1000000;
      resultado += " MΩ";
    }
    else if (resultado >= 1000 && resultado < 1000000) {
      resultado /= 1000;
      resultado += " kΩ";
    } else {
      resultado.toFixed(2);
      resultado += " Ω";
    }
    return resultado;
  }
  render() {
    return (
      <div className='cores'>
        <h1>Calculadora de Bandas</h1>
        <table>
          <tbody>
            <tr>
              <td />
              <td id='f7' />
              <td onClick={this.handleClick} id='ab' />
              <td id='a' />
              <td onClick={this.handleClick} id='ac' />
              <td id='a' />
              <td onClick={this.handleClick} id='ad' />
              <td id='a' />
              <td onClick={this.handleClick} id='ae' />
              <td id='f8' />
              <td />
            </tr>
            <tr id='trm'>
              <td id='h' />
              <td id='f2' />
              <td onClick={this.handleClick} id='ab' />
              <td id='f2' />
              <td onClick={this.handleClick} id='ac' />
              <td id='f2' />
              <td onClick={this.handleClick} id='ad' />
              <td id='f2' />
              <td onClick={this.handleClick} id='ae' />
              <td id='f2' />
              <td id='h1' />
            </tr>
            <tr>
              <td />
              <td id='f5' />
              <td onClick={this.handleClick} id='ab' />
              <td id='a' />
              <td onClick={this.handleClick} id='ac' />
              <td id='a' />
              <td onClick={this.handleClick} id='ad' />
              <td id='a' />
              <td onClick={this.handleClick} id='ae' />
              <td id='f6' />
              <td />
            </tr>
          </tbody>
        </table>
        <h2>{this.calcula()} {this.state.banda4}</h2>
        <div className='botoes'>
          <button onClick={this.mudacorpreto}>Preto</button>
          <button onClick={this.mudacormarrom}>Marrom</button>
          <button onClick={this.mudacorvermelho}>Vermelho</button>
          <button onClick={this.mudacorlaranja}>Laranja</button>
          <button onClick={this.mudacoramarelo}>Amarelo</button>
          <button onClick={this.mudacorverde}>Verde</button>
          <button onClick={this.mudacorazul}>Azul</button>
          <button onClick={this.mudacorvioleta}>Violeta</button>
          <button onClick={this.mudacorcinza}>Cinza</button>
          <button onClick={this.mudacorbranco}>Branco</button>
          <button onClick={this.gold}>Ouro</button>
          <button onClick={this.silver}>Prata</button>
        </div>
      </div>
    );
  }
}

export default Cores;